angular.module 'zc.projects'

.directive 'zcLabelReportStatus', ($translate) ->
  restrict: 'E'
  scope:
    report: '='
  template: """
    <span ng-class="labelClass">{{text}}</span>
  """

  link: (scope, element, attrs) ->
    if scope.report.status == 'trial'
      scope.text = $translate.instant('projects.directives.projects.zcLabelReportStatus.trial')
      scope.labelClass = 'label label-warning'
    else if scope.report.status == 'contracted'
      scope.text = $translate.instant('projects.directives.projects.zcLabelReportStatus.contracted')
      scope.labelClass = 'label label-success'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/zc_label_report_status.coffee